import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'
import usePromiseEvent from '../../hooks/usePromiseEvent'
import { commentSlice } from '../../reducers'
import { CommentInput } from '../comments'
import { CommentSection } from '..'
import { useSession } from '@emerald-works/react-auth'
import { Box } from '@mui/material'
import { useAlert } from '../../hooks'
import { useSEO } from '../seo-context'

const CommentsView = props => {
  const { locationId } = props
  const dispatch = useDispatch()
  const { enqueueMsg } = useAlert()
  const [listComments] = useEvent([commentSlice.eventBus.listComments])

  const { user: sessionUser } = useSession()

  const { attributes: { given_name: givenName, family_name: familyName, ...rest } } = sessionUser || { attributes: {} }

  const user = { givenName, familyName, ...rest }

  const addComment = usePromiseEvent('commentInsert')

  const { comments, total, loading } = useSelector(
    commentSlice.selectors.selectAll
  )

  const [sort, setSort] = useState('newest')

  const handleSort = (event, sort) => {
    setSort(prevSort => sort ?? prevSort)
  }

  const sortedComments =
    sort === 'likes'
      ? comments.slice().sort((a, b) => b.likeCount - a.likeCount)
      : comments

  const handleChange = useCallback(() => {
    listComments.trigger({ locationId })
  }, [listComments, locationId])

  const handleCommentSubmit = useCallback(async value => {
    try {
      dispatch(commentSlice.actions.preAddComment())
      const result = await addComment({ locationId, comment: value, type: 'comment' })
      dispatch(commentSlice.actions.addComment({ ...result, doNotUpdateTotal: true }))
    } catch (err) {
      dispatch(commentSlice.actions.cancelPreAddComment())
      enqueueMsg('Unable to add comment', 'error')
    }
  }, [addComment, locationId, dispatch, enqueueMsg])

  useEffect(() => {
    if (locationId) {
      handleChange()
    }
  }, [locationId, handleChange])

  useSEO(listComments.hasBeenTriggered && !listComments.loading)

  return (
    <Box mt={8}>
      <CommentInput author={user} onSubmit={handleCommentSubmit} />
      <Box mt={4} mb={4}>
        <CommentSection
          comments={sortedComments}
          total={total}
          sort={sort}
          onSort={handleSort}
          loading={loading}
          user={user}
        />
      </Box>
    </Box>
  )
}

export default CommentsView
